import { useToastedMutation } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type {
  VerifyEmailRequest,
  VerifyEmailSignupResponse,
} from '../../../../shared/types/routes/auth/emailVerification';

/**
 * Confirms the email-verification code for the current user via `POST /api/auth/email/verify`. Failures
 * surface to the caller so a wrong code shows inline; the step reserves toasts for unexpected errors.
 * The pending-signup branch answers with where to land (`{ organizationId?, to }`); the
 * authenticated-user branch responds 204 and resolves to undefined.
 */
export function useVerifyEmail() {
  return useToastedMutation({
    mutationFn: async (body: VerifyEmailRequest) =>
      (await post<VerifyEmailRequest, VerifyEmailSignupResponse | undefined>('/api/auth/email/verify', body)).data,
  });
}
